import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    /* Dashboard */
    {
      path: "/dashboard",
      name: "dashboard",
      meta: {
        title: "Flow Modeler",
      },
      component: () => import("./views/pg-dashboard/pg-dashboard.vue"),
      children: [
        /* Panel */
        {
          path: "panel",
          name: "panel",
          meta: {
            title: "Flow Modeler - Painel",
          },
          component: () => import("./components/sdk-panel/sdk-panel-grid/sdk-panel-grid.vue"),
        },

        /* Formulários */
        {
          path: "systems/:system/entitys/:entity",
          name: "entitys",
          meta: {
            title: "Flow Modeler - Entitys",
          },
          component: () => import("./components/sdk-entitys/sdk-entity-list/sdk-entity-list.vue"),
        },

        /* Formulário - User */
        {
          path: ":menuId/systems/configuration/forms/users",
          name: "users",
          meta: {
            title: "Flow Modeler - Usuários",
          },
          component: () => import("./components/sdk-forms/sdk-forms-user/sdk-forms-user.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/users/:user",
          name: "user",
          meta: {
            title: "Flow Modeler - Cadastro de Usuário",
          },
          component: () => import("./components/sdk-forms/sdk-forms-user-single/sdk-forms-user-single.vue"),
        },

        /* Formulário - User Password Change */
        {
          path: ":menuId/systems/configuration/forms/userchange",
          name: "userpwchange",
          meta: {
            title: "Flow Modeler - Alteração de Senha",
          },
          component: () => import("./components/sdk-forms/sdk-forms-user-password/sdk-forms-user-password.vue"),
        },

        /* Formulário - Group */
        {
          path: ":menuId/systems/configuration/forms/groups",
          name: "groups",
          meta: {
            title: "Flow Modeler - Grupos",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group/sdk-forms-group.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/groups/:group",
          name: "group",
          meta: {
            title: "Flow Modeler - Cadastro de Grupo",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group-single/sdk-forms-group-single.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/group-user/:group",
          name: "user-group",
          meta: {
            title: "Flow Modeler - Gerenciar usuários",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group-user-single/sdk-forms-group-user-single.vue"),
        },
        /* Formulário - Group User */
        {
          path: ":menuId/systems/configuration/forms/group-user",
          name: "groupusers",
          meta: {
            title: "Flow Modeler - Grupo Usuários",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group-user/sdk-forms-group-user.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/group-user/:groupuser",
          name: "groupuser",
          meta: {
            title: "Flow Modeler - Cadastro de Usuário por Grupo",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group-user-single/sdk-forms-group-user-single.vue"),
        },
        /* Formulário - Company */
        {
          path: ":menuId/systems/configuration/forms/companies",
          name: "companies",
          meta: {
            title: "Flow Modeler - Empresas",
          },
          component: () => import("./components/sdk-forms/sdk-forms-company/sdk-forms-company.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/companies/:company",
          name: "company",
          meta: {
            title: "Flow Modeler - Cadastro de Empresa",
          },
          component: () => import("./components/sdk-forms/sdk-forms-company-single/sdk-forms-company-single.vue"),
        },

        /* Formulário - System */
        {
          path: ":menuId/systems/configuration/forms/systems",
          name: "systems",
          meta: {
            title: "Flow Modeler - Sistemas",
          },
          component: () => import("./components/sdk-forms/sdk-forms-system/sdk-forms-system.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/systems/:system",
          name: "system",
          meta: {
            title: "Flow Modeler - Cadastro de Sistema",
          },
          component: () => import("./components/sdk-forms/sdk-forms-system-single/sdk-forms-system-single.vue"),
        },

        /* Formulário - Environment */
        {
          path: ":menuId/systems/configuration/forms/environments",
          name: "environments",
          meta: {
            title: "Flow Modeler - Ambientes",
          },
          component: () => import("./components/sdk-forms/sdk-forms-environment/sdk-forms-environment.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/environments/:environment",
          name: "environment",
          meta: {
            title: "Flow Modeler - Cadastro de Ambiente",
          },
          component: () => import("./components/sdk-forms/sdk-forms-environment-single/sdk-forms-environment-single.vue"),
        },

        /* Formulário - Role */
        {
          path: ":menuId/systems/configuration/forms/roles",
          name: "roles",
          meta: {
            title: "Flow Modeler - Papéis",
          },
          component: () => import("./components/sdk-forms/sdk-forms-role/sdk-forms-role.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/roles/:role",
          name: "role",
          meta: {
            title: "Flow Modeler - Cadastro de Papel",
          },
          component: () => import("./components/sdk-forms/sdk-forms-role-single/sdk-forms-role-single.vue"),
        },

        /* Formulário - User Roles */
        {
          path: ":menuId/systems/configuration/forms/user-roles",
          name: "userroles",
          meta: {
            title: "Flow Modeler - Usuário Papel",
          },
          component: () => import("./components/sdk-forms/sdk-forms-user-roles/sdk-forms-user-roles.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/user-roles/:userrole",
          name: "userrole",
          meta: {
            title: "Flow Modeler - Cadastro de Usuário por Papel",
          },
          component: () => import("./components/sdk-forms/sdk-forms-user-roles-single/sdk-forms-user-roles-single.vue"),
        },

        /* Formulário - Group Roles */
        {
          path: ":menuId/systems/configuration/forms/group-roles",
          name: "grouproles",
          meta: {
            title: "Flow Modeler - Grupo Papel",
          },
          component: () => import("./components/sdk-forms/sdk-forms-group-roles/sdk-forms-group-roles.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/group-roles/:grouprole",
          name: "grouprole",
          meta: {
            title: "Flow Modeler - Cadastro de Papel",
          },
          // tslint:disable-next-line:max-line-length
          component: () => import("./components/sdk-forms/sdk-forms-group-roles-single/sdk-forms-group-roles-single.vue"),
        },

        /* Formulário - Configuration Environment */
        {
          path: ":menuId/systems/configuration/forms/configuration-environments",
          name: "configurationenvironments",
          meta: {
            title: "Flow Modeler - Configurações de Ambiente",
          },
          // tslint:disable-next-line:max-line-length
          component: () => import("./components/sdk-forms/sdk-forms-configuration-environment/sdk-forms-configuration-environment.vue"),
        },

        {
          path: ":menuId/systems/configuration/forms/configuration-environments/:configurationenvironment",
          name: "configurationenvironment",
          meta: {
            title: "Flow Modeler - Cadastro de Configuração de Ambiente",
          },
          // tslint:disable-next-line:max-line-length
          component: () => import("./components/sdk-forms/sdk-forms-configuration-environment-single/sdk-forms-configuration-environment-single.vue"),
        },

        /* Formulário - APIs */
        {
          path: ":menuId/systems/apis",
          name: "apis",
          meta: {
            title: "Flow Modeler - APIs",
          },
          // tslint:disable-next-line:max-line-length
          component: () => import("./components/sdk-forms/sdk-forms-api/sdk-forms-api.vue"),
        },

        {
          path: ":menuId/systems/apis/:id",
          name: "api",
          meta: {
            title: "Flow Modeler - Cadastro de API",
          },
          // tslint:disable-next-line:max-line-length
          component: () => import("./components/sdk-forms/sdk-forms-api-single/sdk-forms-api-single.vue"),
        },

        /* Dicionário de Dados - Produto e Tabelas */
        {
          path: ":menuId/systems/:system/products/:product/:version",
          name: "products",
          meta: {
            title: "Flow Modeler - Dicionário de Dados",
          },
          component: () => import("./views/pg-dictionary/pg-dictionary.vue"),
        },

        /* Dicionário de Dados - Landing */
        {
          path: "landing/dictionary",
          name: "landing-dictionary",
          meta: {
            title: "Flow Modeler - Dicionário de Dados",
          },
          component: () => import("./components/sdk-landing/sdk-landing-dictionary/sdk-landing-dictionary.vue"),
        },

        /* Dicionário de Dados - Índice */
        {
          path: ":menuId/systems/:system/:version/index",
          name: "index",
          meta: {
            title: "Flow Modeler - Dicionário de Dados",
          },
          component: () => import("./views/pg-dictionary-index/pg-dictionary-index.vue"),
        },

        /* Dicionário de Dados - Tabela */
        {
          path: ":menuId/systems/:system/tables/:id/:product/:version",
          name: "table",
          meta: {
            title: "Flow Modeler - Dicionário de Dados",
          },
          component: () => import("./views/pg-dictionary-table/pg-dictionary-table.vue"),
        },

        /* Landing Page - APIS */
        {
          path: ":menuId/systems/flow/categories",
          name: "flow-categories",
          meta: {
            title: "Flow Modeler - Categorias de processos",
          },
          component: () => import("./components/sdk-flow-categories/sdk-flow-categories.vue"),
        },

        /* Categories */
        {
          path: ":menuId/systems/flow/categories/:categoryId/:categoryName/:categoryDescription",
          name: "flow-category",
          meta: {
            title: "Flow Modeler - Categorias de processos",
          },
          props: true,
          component: () => import("./components/sdk-flow-category/sdk-flow-category.vue"),
        },

        {
          path: ":menuId/systems/flow/categories/new",
          name: "flow-category-new",
          meta: {
            title: "Flow Modeler - Categorias de processos",
          },
          props: true,
          component: () => import("./components/sdk-flow-category-new/sdk-flow-category-new.vue"),
        },

        {
          path: ":menuId/systems/flow/categories/:categoryId/definitions/:definitionId/:definitionKey",
          name: "flow-definition",
          meta: {
            title: "Flow Modeler - Definição de processos",
          },
          component: () => import("./components/sdk-flow-instance-viewer/sdk-flow-instance-viewer.vue"),
        },

        {
          path: ":menuId/systems/flow/categories/:categoryId/definitions/builder",
          name: "flow-builder",
          meta: {
            title: "Flow Modeler - Modelagem de processos",
          },
          props: true,
          component: () => import("./components/sdk-flow-definition-builder/sdk-flow-definition-builder.vue"),
        },

        {
          path: ":menuId/systems/flow/categories/:categoryId/definitions/builder/:definitionId/:definitionKey",
          name: "flow-edit-definition",
          meta: {
            title: "Flow Modeler - Modelagem de processos",
          },
          props: true,
          component: () => import("./components/sdk-flow-definition-builder/sdk-flow-definition-builder.vue"),
        },

        /* Landing Page - APIS */
        {
          path: "landing/apis" /*'landing/:product',*/,
          name: "landing-apis",
          meta: {
            title: "Flow Modeler - APIs Customizadas",
          },
          component: () => import("./components/sdk-landing/sdk-landing-api/sdk-landing-api.vue"),
        },

        /* Landing Page - APIS */
        {
          path: "landing/flow" /*'landing/:product',*/,
          name: "landing-flow",
          meta: {
            title: "Flow Modeler - MV Flow",
          },
          component: () => import("./components/sdk-landing/sdk-landing-flow/sdk-landing-flow.vue"),
        },

        /* Landing Page - VERSION */
        {
          path: "landing/version" /*'landing/:product',*/,
          name: "landing-version",
          meta: {
            title: "Flow Modeler - Versão",
          },
          component: () => import("./components/sdk-version/sdk-version.vue"),
        },

        /* Landing page - Migrator */
        {
          path: "editor/migrator" /*'landing/:product',*/,
          name: "landing-migrator",
          meta: {
            title: "Flow Modeler - Migrador de documentos",
          },
          component: () => import("./components/sdk-migrator/sdk-migrator.vue"),
        },

        {
          path: "about",
          name: "about",
          meta: {
            title: "Flow Modeler - about",
          },
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ "./views/AboutPage.vue"),
        },

        {
          path: ":menuId/systems/dashboardview",
          name: "dashboardDesign",
          meta: {
            title: "Flow Modeler - Dashboard",
          },
          component: () => import("./components/sdk-dashboard/sdk-dashboard.vue"),
        },
        {
          path: ":menuId/systems/trial",
          name: "trialRequest",
          meta: {
            title: "Flow Modeler - Versão de Teste",
          },
          component: () => import("./components/sdk-trial/sdk-trial.vue"),
        },
        {
          path: ":menuId/systems/api-catalog",
          name: "landing-apis",
          meta: {
            title: "Flow Modeler - Catálogo de APIs",
          },
          component: () => import("./components/sdk-external-apis/sdk-external-apis.vue"),
        },
        {
          name: "catalog",
          path: ":menuId/systems/api-catalog/swagger",
          component: () => import("./components/sdk-external-apis/sdk-api-catalog/sdk-api-catalog.vue"),
          children: [
            {
              name: "api-controller",
              path: ":controllerName",
              component: () => import("./components/sdk-external-apis/sdk-api-catalog/sdk-api-controller/sdk-api-controller.vue"),
            },
          ],
        },
        {
          path: ":menuId/systems/mv-university",
          name: "university-mv",
          meta: {
            title: "Flow Modeler - Universidade MV",
          },
          component: () => import("./components/sdk-mv-university/sdk-mv-university-home/sdk-mv-university-home.vue"),
        },
        {
          name: "university-lessons",
          path: ":menuId/systems/mv-university/:product",
          component: () => import("./components/sdk-mv-university/sdk-mv-universitity-list/sdk-mv-university-list.vue"),
          props: true,
        },
        {
          name: "quiz-home",
          path: ":menuId/systems/quiz/repository",
          meta: {
            title: "Flow Modeler - Questionários",
          },
          component: () => import("./components/sdk-quiz/sdk-quiz-home/sdk-quiz-home.vue"),
        },
        {
          name: "quiz-form",
          path: ":menuId/systems/quiz/repository/:quizId",
          meta: {
            title: "Flow Modeler - Questionários",
          },
          component: () => import("./components/sdk-quiz/sdk-quiz-form/sdk-quiz-form.vue"),
          props: true,
        },
        {
          name: "quiz-bot-status",
          path: ":menuId/systems/quiz/connection",
          meta: {
            title: "Flow Modeler - Questionários",
          },
          component: () => import("./components/sdk-quiz/sdk-quiz-status/sdk-quiz-status.vue"),
        },
        {
          name: "quiz-start-process",
          path: ":menuId/systems/quiz/initial-process",
          meta: {
            title: "Flow Modeler - Questionários",
          },
          component: () => import("./components/sdk-quiz/sdk-quiz-start-process/sdk-quiz-start-process.vue"),
        },
        {
          name: "template-collection",
          path: ":menuId/systems/templates/collection",
          meta: {
            title: "Flow Modeler - Coleção de Templates",
          },
          component: () => import("./components/sdk-template/sdk-template-viewer/sdk-template-viewer.vue"),
        },
        {
          name: "template-management",
          path: ":menuId/systems/templates/management",
          meta: {
            title: "Flow Modeler - Gerencimento de Templates",
          },
          component: () => import("./components/sdk-template/sdk-template-viewer/sdk-template-viewer.vue"),
        },
      ],
    },
    /* Logout */
    {
      path: "/logout",
      name: "logout",
      component: () => import("./views/pg-login/pg-login.vue"),
    },
    /* Login */
    {
      path: "/",
      name: "login",
      component: () => import("./views/pg-login/pg-login.vue"),
    },
    {
      name: "processPrint",
      path: "/process-print/:definitionId",
      component: () => import("./views/pg-print/pg-print.vue"),
      props: true,
    },
    {
      name: "about",
      path: "/about",
      component: () => import("./views/AboutPage.vue"),
      props: true,
    },
  ],
});
